import { loc } from "../../../../../core/utils"
import * as yup from "yup"

export const requiredMessage = () => loc("Required")

const validationSchema = yup.object().shape({
  shop: yup.string().nullable().required(requiredMessage),
  delivery: yup.string().nullable().required(requiredMessage),
  products: yup.array().of(
    yup.object().shape({
      family: yup.string().nullable().required(requiredMessage),
      category: yup.string().nullable().required(requiredMessage),
      price: yup.string().nullable().required(requiredMessage),
      quantity: yup.string().nullable().required(requiredMessage),
      sku: yup.string().nullable().required(requiredMessage)
    })
  )
})

export default validationSchema
